export default {
  title: 'Наверх',
};
